module.exports = __webpack_public_path__ + "static/giant-ant-37dbf7875cffdc6d0eb9073780620bcf.png";